import React from 'react';

import '../../../static/scss/components/userInput.scss';

const UserInput = args => {
  const type = args.type || 'text';
  const { placeholder } = args;
  const invalid = args.invalid || false;
  const theme = args.theme || 'light';
  const pattern = args.pattern || '.{1,}';
  const errorMessage = args.errorMessage || 'error';
  const testId = args.testId || '';

  const validClass = invalid ? 'invalid' : 'valid';

  return (
    <div
      className={`c-userInput c-userInput--${type} c-userInput--${theme} c-userInput--${validClass}`}
    >
      {invalid && <div className="c-userInput__error">{errorMessage}</div>}
      <input
        onChange={e => args.onChange(e.target.value)}
        type={type}
        required
        pattern={pattern}
        placeholder={placeholder}
        value={args.value}
        data-test-id={testId}
        data-cy={testId}
      />
    </div>
  );
};

export default UserInput;
